export const data_zaune =
    {
        category: 'Zaun',
        modell: [
            {
                index: '',
                img: '',
                imgBase64: '',
                titel: '',
                form: '',
                muster: '',
                price: 350
            }
        ],
        tabs: [{tab_index: 0}],
        data_description: [
            {
                image: '',
                file: '',
                description: '',
                isUploadData: false
            }
        ],
        steps: [
            [[false], [false], [false], [false], [false], [false]],
            {
             visited: [0],
             active_steps: []
             }
        ],

        dimensions: [
            {
                dimension: '',
                total_dimension_width: '',
                total_dimension_height: '',
                kind_dimension: '',
                single_width: '',
                single_piece: '',
                single_fields: []
            },
        ],
        colors: [
            {
                kind_of_color: '',
                wish_color: '',
                color_index: '',
                color: '',
            }
        ],
        spitzen: [
            {
                spitze: '',
                index: ''
            }
        ],
        pfosten: [
            {
                ispfosten: false,
                iskappen: false,
                pfosten_width: '',
                kappe: '',
                kappe_index: ''
            }
        ],
        allVisitedSteps: false,
        isEdit: false,
        is_merkliste: false
    }
